import cn from "classnames";

import { Button } from "@/shared/components/ui/button/Button";
import { FA } from "@/shared/components/ui/icon";

import s from "../FileCard.module.scss";
import { FileIcon, MetaTag } from "../FileCard.shared";
import { FileTypeIcon, getFileTypeChipKey } from "../FileCardIcons";
import { formatFileSize } from "../fileCard.utils";
import type { FileCardLayoutProps } from "./fileCardLayout.types";

/** Default layout — horizontal card with icon, metadata tags, and action buttons */
export const FileCardDefault = ({ attrs, orderBaseUrl, onOrder, onDownload }: FileCardLayoutProps) => {
  const hasFile = !!attrs.url;
  const hasOrder = !!orderBaseUrl;
  const hasMeta =
    !!(attrs.customPaperType || attrs.paperTypeLabel) ||
    !!attrs.academicLevelLabel ||
    !!attrs.citationStyleLabel ||
    !!attrs.disciplineLabel;

  return (
    <div className={cn(s.card, !hasOrder && s.cardCompact)}>
      <FileIcon attrs={attrs} />
      <div className={s.infoCol}>
        <div className={s.titleRow}>
          <span className={s.title}>{attrs.title || "Untitled file"}</span>
          {!!attrs.pages && <span className={s.pagesTag}>{attrs.pages} pages</span>}
        </div>
        {!!attrs.description && <div className={s.description}>{attrs.description}</div>}
        {hasMeta && (
          <div className={s.metaTags}>
            {!!(attrs.customPaperType || attrs.paperTypeLabel) && (
              <MetaTag label="Type" value={attrs.customPaperType || attrs.paperTypeLabel} />
            )}
            {!!attrs.academicLevelLabel && <MetaTag label="Level" value={attrs.academicLevelLabel} />}
            {!!attrs.citationStyleLabel && <MetaTag label="Format" value={attrs.citationStyleLabel} />}
            {!!attrs.disciplineLabel && <MetaTag label="Discipline" value={attrs.disciplineLabel} />}
          </div>
        )}
        {hasFile && hasOrder && (
          <div className={s.actions}>
            <Button variant="primary" outlined onClick={onDownload} className={s.actionButton}>
              Download
              <FA icon="fa-download" />
            </Button>
            <a
              href={orderBaseUrl}
              rel="nofollow noopener"
              className={cn(s.orderLink, "file-card-order-link")}
              onClick={(e) => {
                e.preventDefault();
                onOrder();
              }}
            >
              Order similar
              <FA icon="fa-cart-shopping" />
            </a>
          </div>
        )}
      </div>

      {/* No order — download sidebar on the right */}
      {hasFile && !hasOrder && (
        <div className={s.compactSidebar}>
          <Button variant="primary" outlined onClick={onDownload} className={s.actionButton}>
            <FA icon="fa-download" />
            Download
          </Button>
        </div>
      )}
    </div>
  );
};
